__turbopack_context__.v({
  "buttons": "FlexCustomerModal-module___P6E0a__buttons",
  "closeButton": "FlexCustomerModal-module___P6E0a__closeButton",
  "modalBody": "FlexCustomerModal-module___P6E0a__modalBody",
  "restartButton": "FlexCustomerModal-module___P6E0a__restartButton",
  "title": "FlexCustomerModal-module___P6E0a__title",
  "wrapper": "FlexCustomerModal-module___P6E0a__wrapper",
});
